import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/auth/AuthProvider";
import ProductCard from "@/components/ProductCard";
import { Product } from "@/types/product";

const SavedProducts = () => {
  const { user } = useAuth();

  const { data: savedProducts, isLoading } = useQuery({
    queryKey: ['saved-products', user?.id],
    queryFn: async () => {
      console.log('Fetching saved products for user:', user?.id);
      const { data: wishlistItems, error: wishlistError } = await supabase
        .from('wishlists')
        .select('product_id')
        .eq('user_id', user?.id);

      if (wishlistError) {
        console.error('Error fetching wishlist:', wishlistError);
        throw wishlistError;
      }

      if (!wishlistItems?.length) {
        console.log('No saved products found');
        return [];
      }

      const productIds = wishlistItems.map(item => item.product_id);
      
      const { data: products, error: productsError } = await supabase
        .from('products')
        .select('*')
        .in('id', productIds);

      if (productsError) {
        console.error('Error fetching products:', productsError);
        throw productsError;
      }

      console.log('Fetched saved products:', products);
      return products as Product[];
    },
    enabled: !!user?.id
  });

  if (isLoading) {
    return <div className="p-4">Loading saved products...</div>;
  }

  if (!savedProducts?.length) {
    return (
      <div className="p-4 text-center text-muted-foreground">
        No saved products yet
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-4">
      {savedProducts.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
};

export default SavedProducts;